import React, { useCallback, useEffect, useRef, useState, useContext } from 'react';
import style from "./Tab0.module.scss";
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import AppConfig from '../../AppConfig';
import styled from "styled-components";
import EventItem from './EventItem';
import { Button, Collapse, TextField } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import MapSearch from '../../comm/global/components/MapSearch';
import { fetchGet, fetchOptions, fetchPost } from '../../comm/comm';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css'
import { enUS, zhCN } from 'date-fns/locale';
import { format } from 'date-fns';
import * as YStyled from '../../Styleds';
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
import Tab0BottomSheet from '../../comm/global/components/Tab0BottomSheet';

const Bgdiv = styled.div`
  ${props => props.img && `
    background-size: cover;
    background-image: url(${props.img});
    background-size: cover;
  `}
`;
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
}));

const customWeekdayFormatter = (date) => {
    const weekdays = ['週日', '週一', '週二', '週三', '週四', '週五', '週六'];
    return weekdays[date.getDay()];
};
const customMonthFormatter = (date) => {
    // 使用 date-fns 格式化函数
    return `${format(date, "yyyy 年 M 月", { locale: zhCN })} ❯`;
};

const Tab0 = ({ loginData, addModalType, set_menuVisiable }) => {
    const { preProcessEvent, userData } = useContext(GameContext);
    //for map
    const [isOpen, setIsOpen] = useState(true);
    const [canScroll, set_canScroll] = useState(false);
    const [events, set_events] = useState([]);
    const [pageState, set_pageState] = useState("main");//main是有顯示感興趣、keyword是顯示搜尋、pots是顯示所有的點 這時候隱藏感興趣 ,selectPosition 是選取座標以建立新pot
    const [potIndex, set_potIndex] = useState(-1);

    const sliderPannelRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const maskRef = useRef(null);
    const [scrollTop, set_scrollTop] = useState(null);
    const [handUp, setHandUp] = useState(true);
    const [selected, setSelected] = useState();
    //過濾日期後
    const [disEvents, set_disEvents] = useState([]);

    const [isFullScreen, set_isFullScreen] = useState(false);

    useEffect(() => {
        set_disEvents(events)
    }, [events])

    useEffect(() => {
        setIsOpen(true); // 在組件加載時設為 true
        apiManager.fetchGet("event", {}, 0).then(res => {
            const processEvents = async () => {
                const __events = await Promise.all(res.map(async (event) => {
                    return await preProcessEvent(event);
                }));
                set_events(__events);
                set_events(__events);

            };
            processEvents();
        })
    }, []);
    function onPot() {
        if (userData)
            set_pageState("selectPosition");
        else
            window.location.href = AppConfig.registerUrl();
    }
    function onSave() {
        if (userData)
            addModalType({
                cls: "OpenPotList", arg: {
                    cb: () => {
                    },
                    type: "tab0"
                }
            })
        else
            window.location.href = AppConfig.registerUrl();
    }
    return (
        <div className={style.app}>
            <YStyled.Label style={{ width: "90%",aspectRatio:"1/1" }}>
                                            <YStyled.Col align="center" gap=".4rem">
                                                <img src="./assets/ui/coupon.png" />
                                                <YStyled.Span size={17}>開發中</YStyled.Span>
                                                <YStyled.Span size={17}>敬請期待</YStyled.Span>
                                            </YStyled.Col>
                                        </YStyled.Label>

        </div>
    );
}

export default Tab0;
